export default [{
    header: 'Reportes',
    icon: 'PieChartIcon',
    children: [
        {
            title: 'Fondo de Garantía',
            route: 'reports-guarantee-fund',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte CTS',
            route: 'reports-cts',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte CTS Cartas No Adeudos',
            route: 'reports-cts-cartas',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte Gratificación',
            route: 'reports-gratification',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte Gratificación Cartas No Adeudos',
            route: 'reports-gratification-cartas',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'reports'
        }
    ]
},
{
    header: 'Herramientas',
    icon: 'ToolIcon',
    children: [
        {
            title: 'Generar Formularios Prueba',
            route: 'tools-generate-test-forms',
            icon: 'ToolIcon',
            action: 'manage',
		    resource: 'tools'
        }
    ]
}]